<div class="notification-bell">
  <button
    type="button"
    class="notification-bell__button"
    [class.notification-bell__button--active]="isOpen()"
    (click)="togglePanel()"
    aria-label="Abrir notificacoes"
  >
    <span class="notification-bell__icon" aria-hidden="true">🔔</span>

    @if (unreadCount()) {
      <span class="notification-bell__badge">{{ unreadCount() }}</span>
    }
  </button>

  @if (isOpen()) {
    <section class="notification-bell__panel">
      <header class="notification-bell__panel-header">
        <div class="notification-bell__panel-copy">
          <strong>Central de notificacoes</strong>
          <span>
            {{
              notificationStore.connectionState() === 'open'
                ? 'Conectado'
                : 'Aguardando atualizacao'
            }}
          </span>
        </div>

        @if (hasNotifications()) {
          <button
            type="button"
            class="notification-bell__panel-action"
            aria-label="Limpar notificacoes"
            title="Limpar notificacoes"
            (click)="clearNotifications()"
          >
            <span aria-hidden="true">🗑️</span>
          </button>
        }
      </header>

      <lib-ui-notification-list
        [notifications]="panelNotifications()"
        [showHeader]="false"
        (orderOpened)="closePanel()"
      ></lib-ui-notification-list>
    </section>
  }
</div>
